import { Button as AntButton, Modal, Select, TableColumnsType } from 'antd';
import _ from 'lodash';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getLevelUpStudents } from '../../../../api/semesters.api';
import useAxios from '../../../../hooks/useAxios';
import config from '../../../../lib/config';
import moment from 'moment';
import exportTable from '../../../../lib/exportTable';
import { getCommonCodeLabel } from '../../../../lib/store';
import {
  IGetLevelUpStudents,
  ILevelUpStudent,
} from '../../../../models/semesters.model';
import ErrorResponse from '../../../ErrorResponse';
import Loader from '../../../Loader';
import Pagination from '../../../Pagination';
import LevelUpTable from './LevelUpTable';
import { doGetCampuses } from '../../../../store/campus.slice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  levelUpCode: number | undefined;
  semesterCode: string | number;
  courseCode: number | string | undefined;
}

const LevelUpListModal: FC<IProps> = ({
  visible,
  setVisible,
  levelUpCode,
  semesterCode,
  courseCode,
}) => {
  // console.log('semesterCode', semesterCode);
  // console.log('courseCode', courseCode);
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { campuses } = useSelector((state: RootState) => state.campus);
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetLevelUpStudents>();
  // for excel download
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetLevelUpStudents>();

  const [pageNo, setPageNo] = useState(1);
  const [targetCampusCode, setTargetCampusCode] = useState<any>();

  useEffect(() => {
    dispatch(doGetCampuses());
  }, []);

  useEffect(() => {
    if (targetCampusCode && levelUpCode) {
      execute(
        getLevelUpStudents({
          campusCode: targetCampusCode,
          levelUpCode,
          semesterCode,
          courseCode,
          pageNo,
          perPage: config.minimumPageSize,
        }),
      );
    } else if (levelUpCode) {
      execute(
        getLevelUpStudents({
          levelUpCode,
          semesterCode,
          courseCode,
          pageNo,
          perPage: config.minimumPageSize,
        }),
      );
    }
  }, [levelUpCode, pageNo, targetCampusCode]);

  useEffect(() => {
    if (res2 && !isLoading2) {
      // const data = _.cloneDeep(res2?.data);
      const data = _.cloneDeep(res2?.data).filter(
        (item: any) => item.campusCode !== 'CB00000005',
      );
      // console.log('data', data);
      data.forEach((item: any) => {
        item.icoachingAvgScore = item.icoachingAvgScore
          ? Math.round(item.icoachingAvgScore)
          : '';
        item.elearningAvgScore = item.elearningAvgScore
          ? Math.round(item.elearningAvgScore)
          : '';
        item.totalTestScore = item?.totalTestScore?.toFixed(1) || '';
        item.icoachingConversionScore = item.icoachingConversionScore
          ? Math.round(item.icoachingConversionScore)
          : '';
        item.elearningConversionScore = item.elearningConversionScore
          ? Math.round(item.elearningConversionScore)
          : '';
        item.totalConversionScore =
          item?.totalConversionScore?.toFixed(1) || '';
        item.levelUpResultCode = getCommonCodeLabel(
          'GR0005',
          item.levelUpResultCode,
          i18n.language,
        );
        item.campusLevelUpResultCode = getCommonCodeLabel(
          'GR0005',
          item.campusLevelUpResultCode,
          i18n.language,
        );
        item.campusKorName = i18n.language === 'ko' ? item.campusKorName : item.campusEngName;
        item.memberKorName = i18n.language === 'ko' ? item.memberKorName : item.memberEngName;
      });
      const currentDate = moment(new Date());
      exportTable(
        columns,
        data,
        `${t('program.semester.button9')}_(${currentDate.format('YYYYMMDD')})`,
        `${t('program.semester.button9')}`,
        [
          12, 10, 20, 15, 12, 15, 12, 15, 12, 15, 12, 15, 12, 15, 12, 12, 12,
          12,
        ],
      );
    }
  }, [res2, isLoading2]);

  const onDownloadExcel = () => {
    if (targetCampusCode && levelUpCode) {
      execute2(
        getLevelUpStudents({
          campusCode: targetCampusCode,
          levelUpCode,
          semesterCode,
          courseCode,
          pageNo: 1,
          perPage: 9999999,
        }),
      );
    } else if (levelUpCode) {
      execute2(
        getLevelUpStudents({
          levelUpCode,
          semesterCode,
          courseCode,
          pageNo: 1,
          perPage: 9999999,
        }),
      );
    }
    // if (levelUpCode) {
    //   execute2(
    //     getLevelUpStudents({
    //       levelUpCode,
    //       pageNo: 1,
    //       perPage: 9999999,
    //     }),
    //   );
    // }
  };

  const columns: TableColumnsType<ILevelUpStudent> = [
    {
      title: t('student.student.76'),
      dataIndex: 'campusKorName',
    },
    {
      title: t('message.write.1'),
      dataIndex: 'memberKorName',
    },
    {
      title: t('sms.send.4'),
      dataIndex: 'className',
    },
    {
      title: t('program.semester.levelup1'),
      dataIndex: 'studentRegisterCount',
    },
    {
      title: t('program.semester.19'),
      dataIndex: 'monthlyTestScore1',
    },
    {
      title: t('program.semester.20'),
      dataIndex: 'monthlyTestConversionScore1',
    },
    {
      title: t('program.semester.21'),
      dataIndex: 'monthlyTestScore2',
    },
    {
      title: t('program.semester.22'),
      dataIndex: 'monthlyTestConversionScore2',
    },
    {
      title: t('program.semester.23'),
      dataIndex: 'levelTestScore',
    },
    {
      title: t('program.semester.24'),
      dataIndex: 'levelTestConversionScore',
    },
    {
      title: t('program.semester.levelup2'),
      dataIndex: 'icoachingAvgScore',
    },
    {
      title: t('program.semester.levelup3'),
      dataIndex: 'icoachingConversionScore',
    },
    {
      title: t('program.semester.25'),
      dataIndex: 'elearningAvgScore',
    },
    {
      title: t('program.semester.26'),
      dataIndex: 'elearningConversionScore',
    },
    {
      title: t('program.semester.27'),
      dataIndex: 'totalTestScore',
    },
    {
      title: t('program.semester.28'),
      dataIndex: 'totalConversionScore',
    },
    {
      title: t('program.semester.29'),
      dataIndex: 'levelUpResultCode',
    },
    {
      title: t('program.semester.30'),
      dataIndex: 'campusLevelUpResultCode',
    },
    {
      title: t('program.semester.31'),
      dataIndex: 'nextCourseName',
    },
  ];

  const campusSelectHandler = (campusCode: string | null) => {
    console.log(campusCode);
    setPageNo(1);
    setTargetCampusCode(campusCode);
    // if (campusCode) {
    //   execute(
    //     getLevelUpStudents({
    //       campusCode: campusCode,
    //       levelUpCode,
    //       pageNo: 1,
    //       perPage: config.miniPageSize,
    //     }),
    //   );
    // } else {
    //   execute(
    //     getLevelUpStudents({
    //       levelUpCode,
    //       pageNo: 1,
    //       perPage: config.miniPageSize,
    //     }),
    //   );
    // }
  };

  return (
    <>
      {(isLoading || isLoading2) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />

      <Modal
        title={t('program.semester.button9')}
        visible={visible}
        onCancel={() => setVisible(false)}
        width={1100}
        footer={[
          <div className="comm-btn__area justify-content-center">
            <AntButton
              key="submit"
              className="btn-basic green"
              onClick={onDownloadExcel}
            >
              <i className='ic_excel'></i>
              <span>{t('program.semester.button10')}</span>
            </AntButton>
            <AntButton
              key="cancel"
              className="btn-basic gray"
              onClick={() => setVisible(false)}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>,
        ]}
      >
        
        <div className="comm-bx__between">
          <div />
          <ul className="search-bx">
            <li>
              <Select
                defaultValue={null}
                onChange={(campusCode) => campusSelectHandler(campusCode)}
                options={[
                  { label: t('common.text.all'), value: null }, // 전체 옵션 추가
                  ...(campuses?.map((data) => ({
                    label: i18n.language === 'ko' ? data.campusKorName : data.campusEngName,
                    value: data.campusCode,
                  })) || []), // 캠퍼스 데이터를 매핑하여 기존 옵션에 추가
                ]}
              />
            </li>
          </ul>
        </div>

        <LevelUpTable data={res?.data} isModal={true} />
        
        <div className="comm-bx__space">
          <div className="common-paging center">
            <Pagination
              count={res?.total || 0}
              page={pageNo}
              setPage={setPageNo}
              levelupMini={true}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default LevelUpListModal;
